<template>
  <div style="display: flex">
    <div class="mapLeft">
      <div class="targeta">
        <span
            class="seatar mapTitle">Dynamic monitoring of global public opinion of Chinese enterprises and industries</span>
        <div class="elDownload" @click="downloadPicture"><i class="el-icon-download"/></div>
      </div>
      <div id="mapDiv" ref="mapDiv" @click.stop>
        <div class="mapTop">
          <div :class="{IndusorEnter:bool.isIndustry}" class="mapTopFir" @click="bool.isIndustry = true">Industries
          </div>
          <div :class="{IndusorEnter:!bool.isIndustry}" class="mapTopSec" @click="bool.isIndustry = false">Enterprises
          </div>
          <span>Dynamic monitoring of public opinion of Chinese enterprises and
            their industries in 200 countries around the world, default display
            of public opinion of Chinese enterprises in the last 7 days, time
            can be adjusted in the screening function.</span>
        </div>
        <div class="mapBottom">
          <div class="mapBottomText">Heat legend</div>
          <ul>
            <li class="mapBottomFir"></li>
            <li class="mapBottomSec"></li>
            <li class="mapBottomThir"></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="focusRight">
      <div class="targeta">
        <span class="seatar">Focus</span>
        <div class="btnCustom" @click="getUserConfig">
          <img alt="" src="@/views/brand/assets/img/custom.png"/><span>Custom</span>
        </div>
      </div>
      <ul class="focusDetails">
        <li v-for="(item, key) in result.listData" :key="key" v-loading="bool.listLoading">
          <div class="focustitle" @click="toDetail(item)">{{ item.title }}</div>
          <ul class="focusnames">
            <li class="focusnamesFir">
              <div v-if="item.companyTags && item.companyTags.length > 0">
                <span class="focusnamesPink" @click="toCompanyDetail(item.companyTags[0])">{{ item.companyTags[0] | lengthFormate }}</span>

                <!--                <router-link :to="{ name: 'companyDetail', query: {englishName: item.companyTags[0]}}">
                                  <span class="focusnamesPink">{{ item.companyTags[0] | lengthFormate }}</span>
                                </router-link>-->
              </div>
              <div v-if="item.industryTags && item.industryTags.length > 0">
                <span class="focusnamesBlue">{{ item.industryTags[0] | lengthFormate }}</span>
              </div>
            </li>
            <li>
              <div v-if="item.positiveTags && item.positiveTags.length > 0">
                <span class="focusnamesGreen">{{ item.positiveTags[0] | tagFormate }}</span>
              </div>
              <div v-if="item.negativeTags && item.negativeTags.length > 0">
                <span class="focusnamesOrange">{{ item.negativeTags[0] | tagFormate }}</span>
              </div>
            </li>
          </ul>
          <div class="focusfooter">
            <span class="mediaSource">source: {{ item.pubMedia }}</span>
            <span class="mediaSource time">published: {{ item.pubTime | timeFormate }}</span>
            <img alt="" src="@/views/brand/assets/img/customfire.png" class="fire-icon"/>
            <span class="footerNum">{{ item.hotValue }}</span>
          </div>
        </li>
      </ul>
      <div class="rightFooter">
        <i class="el-icon-caret-right"></i>
        <span class="clickMore" @click="clickMore">Click here to see more</span>
        <!--        <router-link to="search?from=homePage"><span class="clickMore">Click here to see more</span></router-link>-->
        <i class="el-icon-caret-left"></i>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="bool.formVisible" class="homeFocusTag" show-close
               title="My Focus">
      <el-form :model="param.userConfig">
        <el-form-item :label-width="paramForm.labelWidth" class="formInput" label="Industry">
          <el-autocomplete v-model="paramDefault.tmpData.industry" :fetch-suggestions="fetchSuggestionsIndustry"
                           class="inline-input" size="small"
                           clearable placeholder="Please enter the industry you want to add"/>
          <el-button class="formInputPlus" icon="el-icon-plus icon-plus" size="mini" type="primary"
                     @click="addIndustry(paramDefault.tmpData.industry)"></el-button>

          <div v-if="param.userConfig && param.userConfig.industries && param.userConfig.industries.length>0"
               class="lengends">
            <el-tag v-for="(item, index) in param.userConfig.industries" :key="index"
                    :disable-transitions="false" closable @close="param.userConfig.industries.splice(index, 1)">
              {{ item }}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item :label-width="paramForm.labelWidth" class="formInput" label="Enterprise">
          <el-autocomplete v-model="paramDefault.tmpData.company" :fetch-suggestions="fetchSuggestionsCompany"
                           class="inline-input" size="small"
                           clearable placeholder="Please enter the enterprise you want to add"/>

          <el-button class="formInputPlus" icon="el-icon-plus icon-plus" size="mini" type="primary"
                     @click="addCompany(paramDefault.tmpData.industry)"></el-button>

          <div v-if="param.userConfig && param.userConfig.companies && param.userConfig.companies.length>0"
               class="lengends">
            <el-tag v-for="(item, index) in param.userConfig.companies" :key="index"
                    :disable-transitions="false" closable @close="param.userConfig.companies.splice(index, 1)">
              {{ item }}
            </el-tag>
          </div>
        </el-form-item>

        <el-form-item :label-width="paramForm.labelWidth" class="formInput formInputSelect"
                      label="Nation">
          <el-select v-model="paramDefault.tmpData.country" clearable filterable placeholder="Please select"
                     size="small">
            <el-option v-for="item in $parent.$parent.paramForm.countries" :key="item" :label="item" :value="item"/>
          </el-select>
          <el-button class="formInputPlus" icon="el-icon-plus icon-plus" size="mini" type="primary"
                     @click="addCountry(paramDefault.tmpData.country)"></el-button>

          <div v-if="param.userConfig && param.userConfig.mediaCountries && param.userConfig.mediaCountries.length>0"
               class="lengends">
            <el-tag v-for="(item, index) in param.userConfig.mediaCountries" :key="index"
                    :disable-transitions="false" closable @close="param.userConfig.mediaCountries.splice(index, 1)">
              {{ item }}
            </el-tag>
          </div>
        </el-form-item>

        <el-form-item :label-width="paramForm.labelWidth" class="formInput formInputTime" label="Time">
          <el-date-picker v-model="param.userConfig.pubTime" clearable
                          :picker-options="$parent.$parent.pickerOptions"
                          end-placeholder="end date" range-separator="——" size="small" start-placeholder="start date"
                          type="daterange"/>
        </el-form-item>

        <el-form-item :label-width="paramForm.labelWidth" class="formInput formSortord" label="Sortord">
          <el-select v-model="param.userConfig.sort" clearable filterable placeholder="Please select" size="small">
            <el-option v-for="(item, index) in paramForm.sort" :key="index" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>

        <el-form-item :label-width="paramForm.labelWidth" class="formInput formEmotional" label="Emotional label type">
          <el-select v-model="param.userConfig.inclination" clearable filterable placeholder="Please select"
                     size="small">
            <el-option v-for="item in paramForm.inclination" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="bool.formVisible = false">Cancel</el-button>
        <el-button v-loading="bool.saveLoading" type="primary" @click="confirmSaveUserConfig">Confirm</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/views/brand/utils/request'
import html2canvas from 'html2canvas'

export default {
  data() {
    return {
      timekey: '',
      image: {imageData: []},
      bool: {
        isIndustry: true,
        formVisible: false,
        formLoading: false,
        saveLoading: false,
        listLoading: false,
        mapLoading: false
      },
      param: {userConfig: {}},
      paramDefault: {
        userConfig: {
          industries: [],
          companies: [],
          mediaCountries: [],
          pubTime: [],
          inclination: null,
          sort: '-PUB_TIME'
        },
        tmpData: {industry: '', company: '', country: ''}
      },
      paramForm: {
        sort: [{value: '-PUB_TIME', label: 'Time in descending order'},
          {value: '-HEAT', label: 'The heat in descending order'}
        ],
        inclination: [
          {label: 'Positive labels', value: 1},
          {label: 'Neutral labels', value: 0},
          {label: 'Negative labels', value: -1},
          {label: 'No limit', value: null}
        ],
        labelWidth: '150px'
      },
      result: {countriesGeo: [], mapData: [], listData: []},
      map: {}
    }
  },
  watch: {
    'bool.isIndustry'(newVal) {
      this.handleAddPoint()
      // const overlays = this.map.getOverlays();
      // for (let i = 0; i < overlays.length; i++) {
      //   const _this = this
      //   overlays[i].addEventListener("mouseover", function () {
      //     var infoWin1 = new T.InfoWindow();
      //     var sContent = "<div style='min-width: 250px;'>" +
      //         "<div style='display: flex;justify-content: space-between;padding-bottom: 10px;align-items: center;'>" +
      //         "<span style='font-weight: 700;font-size: 16px;color: rgb(99, 170, 255);'>-" +
      //         _this.result.mapData[i].location + "-</span>" +
      //         "<span style='font-weight: 700;font-size: 12px;color: rgb(127, 127, 127);'>" +
      //         _this.result.mapData[i].articleNum + " Articles</span>" + "</div>" +
      //         "<div style='display: flex;justify-content: space-between;border-top: 1px solid #ccc;padding-top: 10px;'>" +
      //         "<span style='    background: rgba(236, 128, 141, 1);border-radius: 15px;padding: 0 5px;color: #fff;line-height: 20px;'>" +
      //         (_this.bool.isIndustry ? _this.result.mapData[i].industryName : _this.result.mapData[i].enterpriseName) + "</span>" +
      //         "<div style='display: flex;align-items: center;'>" +
      //         "<img class='infowindowimg' style='float:left;margin:0px 10px' src=' ' width='18' height='18' title='fire'/>" +
      //         "<span style='color: font-weight: 700;font-size: 16px;color:rgb(217, 0, 27);'>" +
      //         (_this.bool.isIndustry ? _this.result.mapData[i].industryValue : _this.result.mapData[i].enterpriseValue) + "</span>" + "</div>" + "</div>" + "</div>";
      //     infoWin1.setContent(sContent);
      //     overlays[i].openInfoWindow(infoWin1);
      //   })
      //   overlays[i].addEventListener("mouseout", function () {
      //     overlays[i].closeInfoWindow();
      //   })
      // }
    }
  },
  filters: {
    lengthFormate(value) {
      if (value && value !== '' && value.length > 20) {
        return value.substring(0, 20) + '...'
      }
      return value
    },
    tagFormate(value) {
      let result = value
      if (value && value !== '') {
        const tagArray = value.split('\\')
        result = tagArray[tagArray.length - 1]
        if (result.length > 20) {
          return result.substring(0, 20) + '...'
        }
      }
      return result
    },
    timeFormate(value) {
      if (value && value !== null && value !== '') {
        return value.substring(3)
      }
      return value
    }
  },
  beforeDestroy() {
    if(this.timekey) {
      clearInterval(this.timekey);
    }
  },
  methods: {
    getUserConfig() {
      if (this.$parent.$parent.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")
        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });
        return
      }
      this.bool.formVisible = true
      this.bool.formLoading = true
      request({method: 'get', url: '/api/client/chinaEnterprise/getUserConfigParam'}).then(result => {
        if (result.data != null) {
          this.param.userConfig = result.data
        }
        this.bool.formLoading = false
      }).catch(result => {
        this.bool.formVisible = false
        if (result.response.status != 403) {
          this.$message.error('read failed')
        }
      })
    },
    confirmSaveUserConfig() {
      const data = JSON.parse(JSON.stringify(this.param.userConfig))
      this.bool.formVisible = true
      this.bool.saveLoading = true
      request({data, method: 'post', url: '/api/client/chinaEnterprise/setUserConfigParam'}).then(result => {
        this.bool.formVisible = false
        this.bool.saveLoading = false
        this.$message.success('saved successfully')
        this.getListData()
        this.getMapData()
      }).catch(result => {
        this.bool.saveLoading = false
        this.$message.error('save failed')
      })
    },
    addIndustry() {
      if (this.paramDefault.tmpData.industry != null && this.paramDefault.tmpData.industry !== '') {
        if (this.param.userConfig.industries.indexOf(this.paramDefault.tmpData.industry) < 0) {
          this.param.userConfig.industries.push(this.paramDefault.tmpData.industry)
          this.paramDefault.tmpData.industry = ''
        } else {
          this.$message.warning('The industry already exists')
        }
      }
    },
    addCompany() {
      if (this.paramDefault.tmpData.company != null && this.paramDefault.tmpData.company !== '') {
        if (this.param.userConfig.companies.indexOf(this.paramDefault.tmpData.company) < 0) {
          this.param.userConfig.companies.push(this.paramDefault.tmpData.company)
          this.paramDefault.tmpData.company = ''
        } else {
          this.$message.warning('The enterprise already exists')
        }
      }
    },
    addCountry() {
      if (this.paramDefault.tmpData.country != null && this.paramDefault.tmpData.country !== '') {
        if (this.param.userConfig.mediaCountries.indexOf(this.paramDefault.tmpData.country) < 0) {
          this.param.userConfig.mediaCountries.push(this.paramDefault.tmpData.country)
          this.paramDefault.tmpData.country = ''
        } else {
          this.$message.warning('The country already exists')
        }
      }
    },
    getListData() {
      this.bool.listLoading = true
      request({method: 'get', url: '/api/client/chinaEnterprise/listData'}).then(result => {
        this.bool.listLoading = false
        for (let i = 0; i < result.data.length; i++) {
          if (result.data[i].positiveTags != null) {
            result.data[i].positiveTags = result.data[i].positiveTags.split(';')
          } else {
            result.data[i].positiveTags = []
          }
          if (result.data[i].negativeTags != null) {
            result.data[i].negativeTags = result.data[i].negativeTags.split(';')
          } else {
            result.data[i].negativeTags = []
          }
          if (result.data[i].inclinationTags != null) {
            result.data[i].inclinationTags = result.data[i].inclinationTags.split(';')
          } else {
            result.data[i].inclinationTags = []
          }
          if (result.data[i].industryTags != null) {
            result.data[i].industryTags = result.data[i].industryTags.split(';')
          } else {
            result.data[i].industryTags = []
          }
          if (result.data[i].mediaCountry != null) {
            result.data[i].mediaCountry = result.data[i].mediaCountry.split(';')
          } else {
            result.data[i].mediaCountry = []
          }
          if (result.data[i].companyTags != null) {
            result.data[i].companyTags = result.data[i].companyTags.split(';')
          } else {
            result.data[i].companyTags = []
          }
          result.data[i].pubTime = new Date(result.data[i].pubTime).toDateString()
        }
        this.result.listData = result.data
      }).catch(result => {
        this.bool.listLoading = false
      })
    },
    drawMap() {
      if (this.result.countriesGeo.length > 0 && this.result.mapData.length > 0) {
        mapData:
            for (let i = 0; i < this.result.mapData.length; i++) {
              for (let j = 0; j < this.result.countriesGeo.length; j++) {
                if (this.result.mapData[i].location === this.result.countriesGeo[j].media_country) {
                  if (this.result.countriesGeo[j].media_geo != null && this.result.countriesGeo[j].media_geo !== '') {
                    const bean = this.result.countriesGeo[j].media_geo.split(',')
                    if (bean.length > 1) {
                      this.result.mapData[i].x = bean[0]
                      this.result.mapData[i].y = bean[1]
                      continue mapData
                    }
                  }
                }
              }
              this.result.mapData.splice(i, 1)
              i--
            }
        for (let i = 0; i < this.result.mapData.length; i++) {
          if (i / this.result.mapData.length < 0.3) {
            this.result.mapData[i].src = 'red'
          } else if (i / this.result.mapData.length < 0.6) {
            this.result.mapData[i].src = 'blue'
          } else {
            this.result.mapData[i].src = 'yellow'
          }
        }
      }

      if (this.map && window.T) {
        this.handleAddPoint() // 标点
      }
    },
    getGeo() {
      request({method: 'get', url: '/api/client/chinaEnterprise/getGeo'}).then(result => {
        this.result.countriesGeo = result.data.filter(item => {
          return item && item != null
        })
        this.drawMap()
      })
    },
    getMapData() {
      this.bool.mapLoading = true
      request({method: 'get', url: '/api/client/chinaEnterprise/mapData'}).then(result => {
        this.bool.mapLoading = false
        this.result.mapData = result.data
        this.drawMap()
      }).catch(result => {
        this.bool.mapLoading = false
      })
    },
    fetchSuggestionsIndustry(queryString, callback) {
      const industryInits = []
      this.$parent.$parent.paramForm.industries.forEach(key => {
        if (queryString != null && queryString !== '') {
          if (key.toLowerCase().indexOf(queryString.toLowerCase()) > -1 && this.param.userConfig.industries.indexOf(key) < 0) {
            industryInits.push({value: key})
          }
        } else {
          industryInits.push({value: key})
        }
      })
      callback(industryInits)
    },
    fetchSuggestionsCompany(queryString, callback) {
      const data = {company: queryString}
      request({data, method: 'post', url: '/api/client/chinaEnterprise/searchCompany'}).then(result => {
        const enterpriseInits = []

        for (let i = 0; i < result.data.rows.length; i++) {
          const bean = result.data.rows[i]
          if (this.param.userConfig && this.param.userConfig.companies) {
            if (this.param.userConfig.companies.indexOf(bean.englishName) < 0) {
              enterpriseInits.push({value: bean.englishName})
            }
          } else {
            enterpriseInits.push({value: bean.englishName})
          }
        }
        callback(enterpriseInits)
      })
    },
    load() {
      this.map = null
      const init = new Promise((resolve, reject) => {
        if (window.T) {
          resolve(window.T)
          reject('error')
        }
      })
      init.then((T) => {
        const bottom_url = 'https://t0.tianditu.gov.cn/vec_w/wmts?' +
            'SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles' +
            '&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=ed564f9c0ee383bb453cd76d135c8fee'
        const config = {layers: [new T.TileLayer(bottom_url)]}
        this.map = new T.Map('mapDiv', config)
        this.map.centerAndZoom(new T.LngLat(116.411794, 39.9068), 3)

        // 隐藏左下角天地图版权信息
        document.getElementsByClassName('tdt-control-copyright tdt-control')[0].style.display = 'none'

        this.map.setMinZoom(2)
        this.map.setMaxZoom(3)
       /* const url = 'https://t0.tianditu.gov.cn/eva_w/wmts?' +
            'SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=eva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles' +
            '&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=ed564f9c0ee383bb453cd76d135c8fee'
        const wmsLayer = new T.TileLayer(url)
        this.map.addLayer(wmsLayer)*/
        // document.getElementsByClassName("tdt-control-copyright")[0].style.display = "none";
        if (this.map && window.T && this.result.mapData.length > 0) {
          this.handleAddPoint() // 标点
        }
      })
    },
    handleAddPoint() {
      if (this.map) {
        try {
          this.map.clearOverLays()
        } catch (e) {
          // console.log(e)
        }
      }
      if (!this.map || this.result.mapData.length <= 0) {
        return
      }
      for (let i = 0; i < this.result.mapData.length; i++) {
        // 创建图片对象
        const icon = new T.Icon({iconUrl: 'null', iconSize: new T.Point(25, 25), iconAnchor: new T.Point(7, 18)})
        const element = this.result.mapData[i]
        // 创建标注对象
        const marker = new T.Marker(new T.LngLat(element.x, element.y), {icon: icon})
        // 向地图上添加标注
        this.map.addOverLay(marker)
        const _this = this

        marker.addEventListener('click', function () {
          const infoWin1 = new T.InfoWindow()
          const industryContent = "<span style='background: rgba(2,167,240,0.87);border-radius: 15px;padding: 0 5px;color: #fff;line-height: 20px;'>"
          const enterpriseContent = "<span style='background: rgba(236, 128, 141, 1);border-radius: 15px;padding: 0 5px;color: #fff;line-height: 20px;'>"
          let sContent = "<div id='marker" + i + "' style='min-width: 250px;'>" +
              "<div style='display: flex;justify-content: space-between;padding-bottom: 10px;align-items: center;'>" +
              "<span style='font-weight: 700;font-size: 14px;color: rgb(99, 170, 255);'>-" +
              element.location + '-</span>' +
              "<span style='font-weight: 700;font-size: 14px;color: rgb(127, 127, 127);'>" +
              element.articleNum + ' Articles</span>' + '</div>' +
              "<div style='display: flex;justify-content: space-between;border-top: 1px solid #ccc;padding-top: 10px;'>"
          if (_this.bool.isIndustry) {
            sContent = sContent + industryContent + element.industryName
          } else {
            sContent = sContent + enterpriseContent + element.enterpriseName
          }
          const endContent = '</span>' +
              "<div style='display: flex;align-items: center;'>" +
              "<img class='infowindowimg' style='float:left;margin:0px 10px' src=' ' width='14' height='14' title='fire'/>" +
              "<span style='color: font-weight: 700;font-size: 14px;color:rgb(217, 0, 27);'>" +
              (_this.bool.isIndustry ? element.industryValue : element.enterpriseValue) + '</span>' + '</div>' + '</div>' + '</div>'
          infoWin1.setContent(sContent + endContent)
          marker.openInfoWindow(infoWin1)


          document.getElementById('marker' + i).addEventListener('mouseover', function () {
            if (_this.timekey) {
              clearInterval(_this.timekey)
            }
          })

          document.getElementById('marker' + i).addEventListener('mouseout', function () {
            _this.roundMap()
          })

        })

        /*marker.addEventListener('mouseout', function () {
          marker.closeInfoWindow()
        })*/
      }
      // icon 图片设置src
      let arr = Array.from(document.getElementsByClassName('tdt-marker-pane'))
      if (arr) {
        arr = Array.from(arr[0].getElementsByTagName('img'))
        for (let i = 0; i < arr.length; i++) {
          if (i / arr.length < 0.3) {
            arr[i].src = require('@/views/brand/assets/img/redcircle.svg')
            arr[i].className = arr[i].className + ' redicon'
          } else if (i / arr.length < 0.6) {
            arr[i].src = require('@/views/brand/assets/img/bluecircle.svg')
            arr[i].className = arr[i].className + ' blueicon'
          } else {
            arr[i].src = require('@/views/brand/assets/img/yellowcircle.svg')
            arr[i].className = arr[i].className + ' yellowicon'
          }
        }
      }
      //如果上个定时器存在，则清除
      if (this.timekey) {
        clearInterval(this.timekey)
      }
      this.roundMap()
    },
    roundMap() {
      if (this.map && this.result.mapData) {
        var mapDataLength = this.result.mapData.length
        var increNum = 0
        const _this = this
        this.timekey = setInterval(function () {
          var nowIndex = increNum % mapDataLength
          const element = _this.result.mapData[nowIndex]
          _this.map.centerAndZoom(new T.LngLat(element.x, element.y), 3)

          let arr = Array.from(document.getElementsByClassName('tdt-marker-pane'))
          if (arr) {
            arr = Array.from(arr[0].getElementsByTagName('img'))
            arr[nowIndex].click()
          }
          increNum++
        }, 3000)
      }
    },
    downloadPicture() {
      if (this.$parent.$parent.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")
        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });
        return
      }
      html2canvas(this.$refs.mapDiv, {useCORS: true}).then(canvas => {
        const imgUrl = canvas.toDataURL('png')
        const creatDom = document.createElement('a')
        document.body.appendChild(creatDom)
        creatDom.href = imgUrl
        creatDom.download = 'mapMonitoring.png'
        creatDom.click()
      })
    },
    initMapData() {
      this.param.userConfig = JSON.parse(JSON.stringify(this.paramDefault.userConfig))
      const date = []
      date[0] = new Date(new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 6)
      date[1] = new Date(new Date().setHours(23, 59, 59, 999))
      this.param.userConfig.pubTime = date
      this.getMapData()
      this.getGeo()
      this.getListData()
    },
    toDetail(item) {
      if (this.$parent.$parent.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")
        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });
        return
      }
      this.$router.push({
        path: '/articleDetail',
        query: {uid: item.uid, pubTime: item.pubTime, source: 'ChinaEnterprise'}
      })
    },
    toCompanyDetail(companyName) {
      if (this.$parent.$parent.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")
        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });
        return
      }
      this.$router.push({
        path: '/companyDetail',
        query: {englishName: companyName}
      })
    },
    clickMore(){
      if (this.$parent.$parent.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")
        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });
        return
      }
      this.$router.push({path: '/search', query: {from: 'homePage', showTab: '2'}});
    }
  }
}
</script>

<style scoped>
* {
  font-family: "微软雅黑";
}

.mapLeft {
  width: 67%;
  height: 100%;
}

#mapDiv {
  height: 562px;
  margin: 10px 15px 0;
  position: relative
}

.focusRight {
  width: 32%;
  height: 100%;
  margin-left: 1%;
}

.targeta {
  display: flex;
  /*height: 36px;*/
  padding: 0 10px;
}

.seatar {
  font-weight: 700;
  font-size: 18px;
  color: #389afe;
}

.mapTitle {
  margin-left: 5px;
}

.elDownload,
.btnCustom {
  margin-left: auto;
}

.el-icon-download {
  font-size: 25px;
  cursor: pointer;
  /*margin-right: 20px;*/
  color: #409eff;
}

.btnCustom {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(245, 154, 35, 1);
  width: 150px;
  height: 30px;
  border-radius: 15px;
  cursor: pointer;
}

.btnCustom img {
  width: 22px;
  height: 22px;
}

.btnCustom span {
  font-weight: 700;
  font-style: normal;
  font-size: 12px;
  color: #ffffff;
  margin-left: 10px;
}

.focusDetails {
  height: 535px;
  margin-top: 10px;
  padding: 0 10px;
}

.focusDetails > li {
  border-top: 1px solid #aaa;
  padding: 10px 0 6px 0;
  /*height: 112px;*/
}

.focusDetails > li:last-child {
  border-bottom: 1px solid #aaa;
}

.focustitle {
  /*height: 30px;*/
  font-weight: bold;
  font-style: normal;
  font-size: 12px;
  color: #183c73;
  line-height: 15px;
  text-align: left;
  cursor: pointer;
  word-break: break-all;

  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
}

.focusnames {
  margin-top: 6px;
  /*height: 50px;*/
}

.focusnames li {
  display: flex;
  font-size: 12px;
  -webkit-transform: scale(0.9);
  transform-origin: 0% 0%;
}

.focusnames li > div {
  /*display: flex;*/
}

.focusnames li > div span {
  border-radius: 15px;
  padding: 0 10px;
  /*height: 20px;*/
}

.focusnamesPink {
  background: rgba(236, 128, 141, 1);
  color: #ffffff;
}

.focusnamesBlue {
  background: rgba(129, 211, 248, 1);
  color: #183c73;
  margin-left: 5px;
}

.focusnamesGreen {
  background: rgba(175, 240, 181, 1);
  color: #08b731;
}

.focusnamesOrange {
  background: rgba(255, 228, 186, 1);
  color: #ff8e1f;
  margin-left: 5px;
}

.focusnamesFir {
  margin-bottom: 5px;
}

.focusfooter {
  margin-top: 6px;
  font-size: 12px;
  letter-spacing: 0.5px;
  color: #aaaaaa;
  text-align: left;
  display: flex;
  align-items: center;
}

.focusfooter .mediaSource {
  filter: contrast(0%);
  -webkit-transform: scale(0.9);
  transform-origin: 0% 0%;

  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
}

.focusfooter .time {
  margin-left: 5px;
}

.focusfooter .fire-icon {
  width: 16px;
  height: 16px;
}

.focusfooter img {
  margin-left: auto;
}

.footerNum {
  font-size: 14px;
  font-weight: 700;
  color: #d9001b;
}

.rightFooter {
  display: flex;
  /*margin-top: 8px;*/
  font-size: 12px;
  color: #2f8eff;
  justify-content: center;
  cursor: pointer;
}

.rightFooter i {
  font-size: 20px;
  margin: 0 8px;
}

div /deep/ .el-dialog {
  text-align: left;
}

div /deep/ .el-dialog__body {
  margin: 0 20px;
  border-bottom: 1px solid #a9aaa9;
  border-top: 1px solid #a9aaa9;
}

div /deep/ .el-dialog__title {
  font-weight: 700;
  font-size: 20px;
  color: rgb(47, 142, 255);
}

div /deep/ .el-dialog__header {
  border-top: 3px solid rgb(47, 142, 255);
}

.formInput /deep/ .el-form-item__content {
  /*display: flex;*/
}

.clickMore {
  color: #2F8EFF;
  font-size: 14px;
}

.formInputPlus {
  margin-left: 10px;
}

.formInput /deep/ .el-input__inner {
  width: 330px;
  /*height: 30px;*/
  line-height: 30px;
}

.formInputSelect /deep/ .el-input__inner {
  width: 330px;
}

.formInputTime,
.formSortord {
  display: inline-block;
}

.formSortord /deep/ .el-input__inner,
.formInputTime /deep/ .el-input__inner {
  width: 330px;
}

.formEmotional /deep/ .el-input__inner {
  width: 330px;
}

.lengends ul li {
  float: left;
  display: flex;
  margin-right: 5px;
  cursor: pointer;
  align-items: center;
  margin-bottom: 5px;
}

.lengendtext {
  font-size: 12px;
  /*margin-top: 5px;*/
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 20px;
  height: 20px;
  /*line-height: 20px;*/
  color: rgba(0, 0, 0, 0.45);
}

.lengendtext .lengenddelete {
  font-size: 18px;
}

.lengendtext .lengenddelete {
  margin-left: 40px;
}

div /deep/ .tdt-marker-pane .redicon:hover {
  width: 50px !important;
  height: 50px !important;
  margin-left: -19px !important;
  margin-top: -33px !important;
  content: url(../assets/img/circleouterred.png);
}

div /deep/ .tdt-marker-pane .blueicon:hover {
  width: 50px !important;
  height: 50px !important;
  margin-left: -19px !important;
  margin-top: -33px !important;
  content: url(../assets/img/circleouterblue.png);
}

div /deep/ .tdt-marker-pane .yellowicon:hover {
  width: 50px !important;
  height: 50px !important;
  margin-left: -19px !important;
  margin-top: -33px !important;
  content: url(../assets/img/circleouteryellow.png);
}

.mapBottom {
  position: absolute;
  z-index: 999;
  bottom: 0;
  left: 0;
  height: 50px;
  width: 230px;
  background: rgba(237, 249, 254, 1);
  text-align: left;
}

.mapBottomText {
  margin-top: 5px;
  margin-left: 10px;
  font-size: 10px;
  color: rgb(47, 142, 255);
  font-weight: 700;
}

.mapBottom ul li {
  float: left;
  width: 55px;
  height: 15px;
  margin-top: 5px;
}

.mapBottomFir {
  background: rgba(217, 0, 27, 0.698039215686274);
  margin-left: 10px;
}

.mapBottomSec {
  background: rgba(255, 255, 128);
  margin-left: 20px;
}

.mapBottomThir {
  background: rgba(2, 167, 240);
  margin-left: 20px;
}

.mapTop {
  position: absolute;
  z-index: 999;
  height: 36px;
  width: 100%;
  background: rgba(255, 255, 255, 0.698039215686274);
  display: flex;
  align-items: center;
}

.mapTop div {
  text-align: center;
  min-width: 90px;
  height: 25px;
  line-height: 25px;
  background: #fff;
  color: rgb(127, 127, 127);
  font-weight: 700;
  font-size: 12px;
}

.mapTop span {
  /*font-family: "Arial Normal", "Arial";*/
  text-align: left;
  font-size: 12px;
  min-width: 92%;
  -webkit-transform: scale(0.8);
  transform-origin: 25% 50%;
  color: #555555;
  line-height: 15px;
  /*filter: contrast(1000%);*/
}

.mapTopFir {
  cursor: pointer;
  /*margin-left: 20px;*/
}

.mapTopSec {
  cursor: pointer;
  /*margin-right: 20px;*/
}

.IndusorEnter {
  background: rgb(47, 142, 255) !important;
  color: #fff !important;
}

div /deep/ .infowindowimg {
  content: url(../assets/img/fire.png);
}

.lengends .el-tag {
  margin-right: 10px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  color: #7F7F7F;
  height: 28px;
  line-height: 26px;
  border-radius: 12px;
  /*margin-top: 16px;*/
}

.homeFocusTag ::v-deep .el-dialog__close {
  font-weight: 200;
  font-size: 30px;
}
</style>

